function getNetworkStatus() {
  const connection = navigator == null ? void 0 : navigator.connection;
  if (connection) {
    return connection.effectiveType;
  } else {
    return null;
  }
}
export {
  getNetworkStatus
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IkFBQ08sU0FBUyxtQkFBa0M7QUFDaEQsUUFBTSxhQUFjLHVDQUFtQjtBQUN2QyxNQUFJLFlBQVk7QUFDZCxXQUFPLFdBQVc7QUFBQSxFQUNwQixPQUFPO0FBQ0wsV0FBTztBQUFBLEVBQ1Q7QUFDRiIsIm5hbWVzIjpbXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbC91dGlscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyDojrflj5bnvZHnu5znirbmgIFcbmV4cG9ydCBmdW5jdGlvbiBnZXROZXR3b3JrU3RhdHVzKCk6IHN0cmluZyB8IG51bGwge1xuICBjb25zdCBjb25uZWN0aW9uID0gKG5hdmlnYXRvciBhcyBhbnkpPy5jb25uZWN0aW9uO1xuICBpZiAoY29ubmVjdGlvbikge1xuICAgIHJldHVybiBjb25uZWN0aW9uLmVmZmVjdGl2ZVR5cGU7XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cbn1cbiJdfQ==